import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { ManagerScheduleSettingsRequest } from '@services/associations/model/managerScheduleSettingsRequest';
import { ManagerScheduleSettingsResponse } from '@services/associations/model/managerScheduleSettingsResponse';

export enum SettingsActionTypes {
  LoadManagerScheduleSettings = '[Settings] Load Manager Schedule Settings',
  LoadManagerScheduleSettingsSuccess = '[Settings] Load Manager Schedule Settings Success',
  LoadManagerScheduleSettingsFailure = '[Settings] Load Manager Schedule Settings Failure',
  UpsertManagerScheduleSettings = '[Settings] Upsert Manager Schedule Settings',
  UpsertManagerScheduleSettingsSuccess = '[Settings] Upsert Manager Schedule Settings Success',
  UpsertManagerScheduleSettingsFailure = '[Settings] Upsert Manager Schedule Settings Failure',
  DeleteManagerScheduleSettings = '[Settings] Delete Manager Schedule Settings',
  DeleteManagerScheduleSettingsSuccess = '[Settings] Delete Manager Schedule Settings Success',
  DeleteManagerScheduleSettingsFailure = '[Settings] Delete Manager Schedule Settings Failure',
  SetFilter = '[Settings] Set Filter',
  ClearFilter = '[Settings] Clear Filter',
  SetInitialState = '[Settings] Set Initial State',
}

/** Load Manager Schedule Settings */
export class LoadManagerScheduleSettings implements Action {
  readonly type = SettingsActionTypes.LoadManagerScheduleSettings;
  constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadManagerScheduleSettingsSuccess implements Action {
  readonly type = SettingsActionTypes.LoadManagerScheduleSettingsSuccess;
  constructor(public payload: ManagerScheduleSettingsResponse[]) {}
}

export class LoadManagerScheduleSettingsFailure implements Action {
  readonly type = SettingsActionTypes.LoadManagerScheduleSettingsFailure;
  constructor(public payload: HttpErrorResponse) {}
}

/** Upsert Manager Schedule Settings */
export class UpsertManagerScheduleSettings implements Action {
  readonly type = SettingsActionTypes.UpsertManagerScheduleSettings;
  constructor(public payload: {managerId: string, request: ManagerScheduleSettingsRequest}) {}
}

export class UpsertManagerScheduleSettingsSuccess implements Action {
  readonly type = SettingsActionTypes.UpsertManagerScheduleSettingsSuccess;
  constructor(public payload: ManagerScheduleSettingsResponse) {}
}

export class UpsertManagerScheduleSettingsFailure implements Action {
  readonly type = SettingsActionTypes.UpsertManagerScheduleSettingsFailure;
  constructor(public payload: HttpErrorResponse) {}
}

/** Delete Manager Schedule Settings */
export class DeleteManagerScheduleSettings implements Action {
  readonly type = SettingsActionTypes.DeleteManagerScheduleSettings;
  constructor(public payload: string) {}
}

export class DeleteManagerScheduleSettingsSuccess implements Action {
  readonly type = SettingsActionTypes.DeleteManagerScheduleSettingsSuccess;
  constructor(public payload: string) {}
}

export class DeleteManagerScheduleSettingsFailure implements Action {
  readonly type = SettingsActionTypes.DeleteManagerScheduleSettingsFailure;
  constructor(public payload: HttpErrorResponse) {}
}

/** Set Filter */
export class SetFilter implements Action {
  readonly type = SettingsActionTypes.SetFilter;
  constructor(public payload: {id: string, name: string}) {}
}

/** Clear Filter */
export class ClearFilter implements Action {
  readonly type = SettingsActionTypes.ClearFilter;
}

/** Set Initial State */
export class SetInitialState implements Action {
  readonly type = SettingsActionTypes.SetInitialState;
}

export type SettingsActions =
  | LoadManagerScheduleSettings
  | LoadManagerScheduleSettingsSuccess
  | LoadManagerScheduleSettingsFailure
  | UpsertManagerScheduleSettings
  | UpsertManagerScheduleSettingsSuccess
  | UpsertManagerScheduleSettingsFailure
  | DeleteManagerScheduleSettings
  | DeleteManagerScheduleSettingsSuccess
  | DeleteManagerScheduleSettingsFailure
  | SetFilter
  | ClearFilter
  | SetInitialState
  ;

